import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['image'];
  originalSrc = '';

  connect() {
    this.originalSrc ||= this.imageTarget.src;
  }

  changeHandler(event) {
    const file = event.target.files[0];
    this.imageTarget.src = file ? URL.createObjectURL(file) : this.originalSrc;
  }
}
